import { makeOptionsWithNull } from 'Common/FormHelper';

export const ICON_POSITIONS = {
  TOP_RIGHT: 'top-right',
  CENTER_RIGHT: 'center-right',
  BOTTOM_RIGHT: 'bottom-right',
};

export const DEFAULT_PAGE_SIZE = 25;

export const TOOLBAR_HEIGHT = 114;

export const BANNER_HEIGHT = 50;

export const NUM_ITEMS = 6;

export const ITEM_HEIGHT = 80;

export const SCROLLING_LIST_HEIGHT = NUM_ITEMS * ITEM_HEIGHT;

export const MEAL_COMPONENTS = [
  'Milk',
  'Meat/Alt',
  'Whole Grain',
  'Enriched Grain',
  'Dark Green Veg.',
  'Red/Orange Veg.',
  'Beans, Peas, Lentils Veg.',
  'Starchy Veg.',
  'Other Veg.',
  'Additional Veg.',
  'Fruit',
  'Juice',
  'Dessert',
];

export const MEAL_COMPONENT_OPTIONS = makeOptionsWithNull(
  MEAL_COMPONENTS.map((item, index) => ({
    Description: item,
    Id: index,
  }))
);

export const WEEKLY_NUTRIENTS = [
  {
    Id: 1,
    Description: 'Calories',
  },
  {
    Id: 2,
    Description: 'Saturated Fat',
  },
  {
    Id: 3,
    Description: 'Sodium',
  },
];

export const EQUALITY_SIGNS = [
  {
    Description: '<',
    Id: 1,
  },
  {
    Description: '>',
    Id: 2,
  },
];

export const REMAINING_LIST_ITEMS_THRESHOLD = 7;



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/constants/index.js